import { SubscriptionSummary } from "@/types/businessData";
import { clsx, type ClassValue } from "clsx";
import { Timestamp } from "firebase/firestore";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function removeUndefinedProperties<T extends Record<string, any>>(
  obj: T
): T {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  ) as T;
}

export function getCandidateAge(
  birthday: string | Timestamp | undefined
): number | null {
  if (!birthday) return null;

  let birthYear: number;
  if (birthday instanceof Timestamp) {
    birthYear = birthday.toDate().getFullYear();
  } else if (typeof birthday === "string") {
    // Handle string format (assuming YYYY-MM-DD or similar)
    birthYear = parseInt(birthday.substring(0, 4));
  } else {
    return null;
  }

  return new Date().getFullYear() - birthYear;
}

export function isSubscriptionActive(
  subscription: SubscriptionSummary | null | undefined
): boolean {
  if (
    subscription &&
    subscription.status !== "trialing" &&
    subscription.status !== "active"
  ) {
    console.log("Subscription is not active", subscription);
    return false;
  }

  return true;
}

export function guardViewFromNotActive(
  subscription: SubscriptionSummary | null | undefined
): boolean {
  if (!isSubscriptionActive(subscription)) {
    return false;
  }

  return true;
}
